/*
  dixed-suche.js  ·  Notbehelf für die kaputte Shopify-Standardsuche
  angelegt 01.09.2026

  Das Problem, gemessen am 01.09.2026 gegen die Live-Storefront:
  Ohne Anführungszeichen liefert JEDE Eingabe rund 174 von 178 Produkten,
  auch "qqqqqq" und "xylophonkonzert". Mit Anführungszeichen arbeitet
  dieselbe Suchmaschine fehlerfrei: "tasse" 12, "hoodie" 16, "emaille" 1,
  "qqqqqq" null. Defekt ist also nur der Modus, in dem Kunden suchen.

  Was dieses Skript tut, an drei Stellen:
    1. Beim Absenden eines Suchformulars wird jedes Wort der Eingabe einzeln
       in Anführungszeichen gelegt. Jedes Wort einzeln, NICHT die ganze
       Eingabe als eine Phrase: "hoodie herren" liefert null, während
       "hoodie" "herren" vier Treffer liefert.
    2. Beim Anzeigen werden die Anführungszeichen wieder entfernt, im
       Suchfeld und in den Statuszeilen. Der Kunde soll sie nie sehen.
    3. Das Aufklappmenü (Dawns predictive-search) fragt an derselben
       Schnittstelle nach und bekommt dieselbe Behandlung.

  Das ist ein Verband, keine Heilung. Sobald Shopify den Suchmodus dieses
  Shops repariert, kann die Datei ersatzlos raus. Sie ist so gebaut, dass
  sie dann nicht stört: Eine bereits gequotete Eingabe wird nicht erneut
  gequotet, und ohne Treffer verändert sie nichts.
*/
(function () {
  'use strict';

  var MARKE = 'data-dx-suche';

  /* Aus der Kundeneingabe die Anfrage bauen, die Shopify versteht. */
  function quoten(eingabe) {
    if (!eingabe) return '';
    var worte = String(eingabe).trim().split(/\s+/).filter(Boolean);
    if (!worte.length) return '';
    // Schon gequotet? Dann nichts tun. Sonst entstünde ""tasse"".
    if (worte.every(function (w) { return /^".*"$/.test(w); })) {
      return worte.join(' ');
    }
    return worte
      .map(function (w) { return w.replace(/"/g, ''); })
      .filter(Boolean)
      .map(function (w) { return '"' + w + '"'; })
      .join(' ');
  }

  /* Für die Anzeige: die Anführungszeichen wieder heraus. */
  function entquoten(text) {
    if (!text) return '';
    return String(text).replace(/"/g, '').replace(/\s+/g, ' ').trim();
  }

  /* 1. Absenden ------------------------------------------------------- */
  document.addEventListener(
    'submit',
    function (ereignis) {
      var formular = ereignis.target;
      if (!formular || !formular.matches) return;
      if (!formular.matches('form[action*="/search"]')) return;

      var feld = formular.querySelector('input[name="q"]');
      if (!feld) return;
      var roh = feld.value;
      if (!roh || !roh.trim()) return;

      var gequotet = quoten(roh);
      if (gequotet === roh) return;
      feld.value = gequotet;

      // Der Kunde soll die Anführungszeichen nicht aufblitzen sehen,
      // während die neue Seite lädt.
      window.setTimeout(function () {
        try { feld.value = roh; } catch (e) {}
      }, 0);
    },
    true // capture: vor Dawns eigenen Submit-Handlern
  );

  /* 2. Anzeigen ------------------------------------------------------- */
  function anzeigeSaeubern() {
    document.querySelectorAll('input[name="q"]').forEach(function (feld) {
      if (feld.value && feld.value.indexOf('"') !== -1) {
        feld.value = entquoten(feld.value);
      }
    });

    // Der Seitentitel wird serverseitig gebaut und trägt die Anführungszeichen
    // sonst in den Browser-Tab. Nur auf der Suchseite anfassen, damit an
    // anderer Stelle keine Produktnamen mit Anführungszeichen beschnitten
    // werden, etwa "Balkan Girl" - Frauen Cropped Tank Top.
    if (location.pathname.indexOf('/search') === 0 && document.title.indexOf('"') !== -1) {
      document.title = entquoten(document.title);
    }

    // Statuszeilen wie "Ergebnisse für "tasse"" und "Keine Ergebnisse für ...".
    var auswahl = '[role="status"], .search__title, #ProductCountDesktop, .product-count';
    document.querySelectorAll(auswahl).forEach(function (knoten) {
      if (knoten.hasAttribute(MARKE)) return;
      if (!knoten.textContent || knoten.textContent.indexOf('"') === -1) return;
      // Nur die gequoteten Wortgruppen ersetzen, den Rest des Satzes lassen.
      knoten.textContent = knoten.textContent.replace(
        /"([^"]+)"(\s+"[^"]+")*/g,
        function (treffer) { return entquoten(treffer); }
      );
      knoten.setAttribute(MARKE, 'bereinigt');
    });
  }

  /* 2b. Rückfallebene auf der Ergebnisseite ---------------------------

     Die Phrasensuche ist streng. Gemessen am 01.09.2026 an sechzehn
     realistischen Kundeneingaben: zehn davon liefern gequotet NULL Treffer,
     darunter "geschenk", "buero", "kollege" und "poster". Es liegt nicht am
     UND bei mehreren Wörtern, sondern daran, dass die Phrase exakt trifft,
     ohne Wortstamm und ohne Umlautnormalisierung: "buero" findet "Büro" nicht.

     Ohne diesen Rückfall wäre der Behelf schlimmer als das Problem: 174
     unpassende Treffer sind schlecht, eine leere Seite ist schlechter, weil
     der Kunde dann abbricht.

     Deshalb: Liefert die gequotete Suche nichts, wird einmal ungequotet
     nachgeladen. Das ist exakt der Zustand vor diesem Behelf, die
     Relevanzsortierung arbeitet dort korrekt. Damit kann der Behelf nur
     verbessern und nie verschlechtern. */
  function rueckfallSeite() {
    if (location.pathname.indexOf('/search') !== 0) return;
    var parameter = new URLSearchParams(location.search);
    var q = parameter.get('q');
    if (!q || q.indexOf('"') === -1) return;   // war nicht gequotet
    if (parameter.get('dx_rueckfall')) return; // genau einmal, nie in Schleife

    var karten = document.querySelectorAll(
      '#product-grid a[href*="/products/"], .product-grid a[href*="/products/"]'
    );
    if (karten.length) return;                 // es gab Treffer, alles gut

    var roh = entquoten(q);
    if (!roh || roh === q) return;
    parameter.set('q', roh);
    parameter.set('dx_rueckfall', '1');
    location.replace(location.pathname + '?' + parameter.toString());
  }

  function beimLaden() {
    anzeigeSaeubern();
    rueckfallSeite();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beimLaden);
  } else {
    beimLaden();
  }
  // Dawn tauscht Ergebnislisten per Ajax aus, deshalb nachfassen.
  document.addEventListener('shopify:section:load', anzeigeSaeubern);

  /* 3. Aufklappmenü ---------------------------------------------------- */

  /* Ersetzt den gequoteten Begriff in den Texten des Aufklappmenüs durch die
     rohe Eingabe. Bewusst nur diese eine Zeichenfolge und nur in Textknoten:
     Ein pauschales Entfernen aller Anführungszeichen würde Produktnamen
     beschädigen, etwa "Balkan Girl" - Frauen Cropped Tank Top. */
  function ersetzeInTexten(wurzel, gequotet, roh) {
    if (!wurzel || !gequotet || gequotet === roh) return;
    var lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, null);
    var knoten;
    while ((knoten = lauf.nextNode())) {
      if (knoten.nodeValue.indexOf(gequotet) !== -1) {
        knoten.nodeValue = knoten.nodeValue.split(gequotet).join(roh);
      }
    }
  }

  function patchePredictive() {
    var klasse = window.customElements && window.customElements.get('predictive-search');
    if (!klasse || !klasse.prototype) return false;
    var proto = klasse.prototype;
    if (proto.__dxSchonGepatcht) return true;

    var holen = proto.getSearchResults;
    var zeichnen = proto.renderSearchResults;
    if (typeof holen !== 'function') return false;

    proto.getSearchResults = function (suchbegriff) {
      this.__dxRoh = suchbegriff;
      this.__dxAnfrage = quoten(suchbegriff);
      this.__dxImRueckfall = false;   // neue Eingabe, Rückfall wieder erlaubt
      return holen.call(this, this.__dxAnfrage);
    };

    /* Kein MutationObserver. Der Bereich, in den geschrieben wird, ist genau
       der beobachtete, und das hat am 31.08.2026 schon einmal die Seite samt
       Browser-Tab zum Hängen gebracht. Der Patch greift stattdessen genau
       dort, wo das Markup eingesetzt wird, also genau einmal je Antwort. */
    if (typeof zeichnen === 'function') {
      proto.renderSearchResults = function (markup) {
        var ergebnis = zeichnen.call(this, markup);
        ersetzeInTexten(this, this.__dxAnfrage, this.__dxRoh);

        /* Dieselbe Rückfallebene wie auf der Ergebnisseite: Liefert die
           gequotete Anfrage kein einziges Produkt, wird einmal ungequotet
           nachgefasst. Aufgerufen wird dabei die UNgepatchte Methode, damit
           kein zweiter Quote-Durchgang und keine Schleife entsteht. */
        var hatProdukte = this.querySelector(
          '[data-predictive-search] a[href*="/products/"]'
        );
        if (!hatProdukte && !this.__dxImRueckfall &&
            this.__dxAnfrage && this.__dxAnfrage !== this.__dxRoh) {
          this.__dxImRueckfall = true;
          this.__dxAnfrage = this.__dxRoh;  // ab jetzt nichts mehr ersetzen
          holen.call(this, this.__dxRoh);
        }
        return ergebnis;
      };
    }

    proto.__dxSchonGepatcht = true;
    return true;
  }

  if (!patchePredictive()) {
    // predictive-search.js wird möglicherweise später registriert.
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('predictive-search').then(patchePredictive);
    }
  }
})();
